module.exports = __webpack_public_path__ + "contacts-cbf4f629/free-cover-3afb766bab04848423d6efdb4f226321.svg";